import Alpine from 'alpinejs'
import Collapsible from './Collapsible'
import Marquee from './Marquee'

// initialize alpineJS
Alpine.data('collapsible', Collapsible)
Alpine.data('marquee', Marquee)
window.Alpine = Alpine;
Alpine.start()
